import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e354c4b")

_pushScopeId("data-v-4e354c4b")
const _hoisted_1 = { class: "application-approval-request" }
const _hoisted_2 = { class: "mr-4 background-member" }
const _hoisted_3 = { class: "text-gray-600" }
const _hoisted_4 = { class: "background-member mr-4 mt-1" }
const _hoisted_5 = { class: "text-gray-600" }
const _hoisted_6 = {
  key: 1,
  class: "background-member mr-4 mt-1"
}
const _hoisted_7 = { class: "text-gray-600" }
const _hoisted_8 = { class: "background-member mr-4 mt-1" }
const _hoisted_9 = { class: "text-gray-600" }
const _hoisted_10 = {
  key: 3,
  class: "background-member mt-1"
}
const _hoisted_11 = { class: "text-gray-600" }
const _hoisted_12 = { class: "flex mb-4 items-center" }
const _hoisted_13 = { class: "text-base mr-6 w-24" }
const _hoisted_14 = { class: "value-member" }
const _hoisted_15 = { class: "flex mb-4 items-center" }
const _hoisted_16 = { class: "text-base mr-6 w-24" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "flex mb-4 items-center" }
const _hoisted_19 = { class: "text-base mr-6 w-24" }
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = { class: "application-approval-table w-fit" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "flex items-center w-100" }
const _hoisted_24 = { class: "truncate-2-line" }
const _hoisted_25 = { class: "flex items-center flex-col" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { key: 2 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ApplicationUserInfo = _resolveComponent("ApplicationUserInfo")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ApplicationSearchArea = _resolveComponent("ApplicationSearchArea")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ApplicationUserInfo, { userInfo: _ctx.userInfo }, null, 8, ["userInfo"]),
    _createVNode(_component_ApplicationSearchArea, {
      onClose: _ctx.closeSearchDetail,
      onReset: _ctx.resetSearchInput,
      onSearch: _ctx.searchMembers
    }, {
      compact: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.t('applicationDateFind')) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.paramsSearchApplication.target_date), 1)
        ], 512), [
          [_vShow, _ctx.paramsSearchApplication.target_date]
        ]),
        (
            _ctx.paramsSearchApplication.application_form_status.length <
            _ctx.listStatus.length
          )
          ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.paramsSearchApplication.application_form_status, (item) => {
              return (_openBlock(), _createBlock("div", { key: item }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, _toDisplayString(_ctx.t('status')), 1),
                  _createTextVNode(": " + _toDisplayString(_ctx.listStatus.find((e) => e.value === item).label), 1)
                ])
              ]))
            }), 128))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('status')) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t('applicationApprovalContent.all')), 1)
            ])),
        (
            _ctx.paramsSearchApplication.application_define_ids.length <
            _ctx.listDefine.length
          )
          ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.paramsSearchApplication.application_define_ids, (item) => {
              return (_openBlock(), _createBlock("div", { key: item }, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t('applicationType2')), 1),
                  _createTextVNode(": " + _toDisplayString(_ctx.listDefine.find((e) => e.value === item).label), 1)
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (
            _ctx.paramsSearchApplication.application_define_ids.length ===
            _ctx.listDefine.length
          )
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('applicationType2')) + ":", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t('applicationApprovalContent.all')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      form: _withId(() => [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('applicationDateFind')), 1),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_DatePicker, {
              format: "YYYY/MM/DD",
              modelValue: _ctx.paramsSearchApplication.target_date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paramsSearchApplication.target_date = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('status')), 1),
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_Checkbox, {
              class: "mr-8",
              label: _ctx.t('applicationApprovalContent.all'),
              fontSize: 14,
              onClick: _ctx.checkAllStatus,
              modelValue: _ctx.checkAllSelectedStatus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkAllSelectedStatus = $event))
            }, null, 8, ["label", "onClick", "modelValue"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
              return (_openBlock(), _createBlock(_component_Checkbox, {
                modelValue: _ctx.paramsSearchApplication.application_form_status,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.paramsSearchApplication.application_form_status = $event)),
                value: item.value,
                label: item.label,
                key: item,
                class: "mr-6",
                fontSize: 14
              }, null, 8, ["modelValue", "value", "label"]))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.t('applicationType2')), 1),
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_Checkbox, {
              class: "mr-8",
              label: _ctx.t('applicationApprovalContent.all'),
              fontSize: 14,
              onClick: _ctx.checkAll,
              modelValue: _ctx.checkAllSelected,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkAllSelected = $event))
            }, null, 8, ["label", "onClick", "modelValue"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listDefine, (item) => {
              return (_openBlock(), _createBlock(_component_Checkbox, {
                key: item,
                class: "mr-8",
                value: item.value,
                label: item.label,
                fontSize: 14,
                modelValue: _ctx.paramsSearchApplication.application_define_ids,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.paramsSearchApplication.application_define_ids = $event))
              }, null, 8, ["value", "label", "modelValue"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["onClose", "onReset", "onSearch"]),
    _createVNode("div", _hoisted_21, [
      _createVNode(_component_Table, {
        headers: _ctx.applicationHeaders,
        data: _ctx.applicationData,
        fixedLeft: 0,
        initMaxHeight: 700,
        itemText: "id",
        "current-page": _ctx.paramsSearchApplication.page,
        "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => (_ctx.paramsSearchApplication.page = $event)),
        "record-total": _ctx.pagination.total,
        "items-per-pages": _ctx.paramsSearchApplication.number_per_page,
        "onUpdate:items-per-pages": _cache[7] || (_cache[7] = ($event: any) => (_ctx.paramsSearchApplication.number_per_page = $event)),
        "show-item-per-page": "",
        "is-pagination": "",
        onOnChangePage: _ctx.onChangePage,
        onChangeItemPerPage: _ctx.onChangeItemPerPage
      }, {
        "data-created_at": _withId(({ item }) => [
          _createVNode("div", _hoisted_22, [
            _createVNode("p", null, _toDisplayString(_ctx.formatDate(item)), 1),
            _createVNode("p", null, _toDisplayString(_ctx.formatDate(item, true)), 1)
          ])
        ]),
        "data-application_status": _withId(({ item }) => [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", {
              class: ["circle", 
                _ctx.applicationStatusTypeList.find((e) => e.value === item)?.color
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.applicationStatusTypeList.find((e) => e.value === item)?.text), 1)
          ])
        ]),
        "data-function_detail": _withId(({ dataRow }) => [
          _createVNode("div", {
            class: "cursor-pointer text-blue-700 text-base btn-detail",
            onClick: ($event: any) => (_ctx.workRecordApplication(dataRow))
          }, _toDisplayString(_ctx.t('applicationApprovalContent.detailApplication')), 9, ["onClick"])
        ]),
        "data-application_reason": _withId(({ item }) => [
          _createVNode("div", _hoisted_24, _toDisplayString(item), 1)
        ]),
        "data-target_date": _withId(({ item }) => [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, _toDisplayString(_ctx.formatDate(item)), 1)
          ])
        ]),
        "data-next_approval_name": _withId(({ dataRow }) => [
          (dataRow.next_approval_name?.length)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "flex items-center truncate-5-line",
                innerHTML: _ctx.nextApproval(dataRow.next_approval_name)
              }, null, 8, ["innerHTML"]))
            : (dataRow.next_role_name?.length)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "flex items-center truncate-5-line",
                  innerHTML: _ctx.nextApproval(dataRow.next_role_name)
                }, null, 8, ["innerHTML"]))
              : (_openBlock(), _createBlock("div", _hoisted_27, "-"))
        ]),
        _: 1
      }, 8, ["headers", "data", "current-page", "record-total", "items-per-pages", "onOnChangePage", "onChangeItemPerPage"])
    ])
  ]))
})